import { SalesReasonDetails, ReturnDetailsObject, DeliveryInvoiceDetailType } from "../../types/types";

export interface CollectionsState {
  disableEditing: boolean;
  updatedInvoiceDetails: DeliveryInvoiceDetailType | null;
  deliveryStatus: string | null;
  returnDetails: ReturnDetailsObject | null;
  batchDetails: {[key:string]:{[key:string]:SalesReasonDetails[]}} | null;
}

const initialState: CollectionsState = {
  disableEditing: false,
  deliveryStatus: null,
  returnDetails:null,
  batchDetails: null,
  updatedInvoiceDetails: null
};

const collectionReducer = (state = initialState, action: any): CollectionsState => {
  switch (action.type) {
    case "setCollectionDisableEditing":
      return { ...state, disableEditing: action.payload };
    case "setDeliveryStatus":
      return { ...state, deliveryStatus: action.payload };
    case "setReturnDetails":
      return { ...state, returnDetails: action.payload };
    case "setBatchDetails":
        return { ...state, batchDetails: action.payload };
    case "setUpdatedInvoiceDetails":
      return { ...state, updatedInvoiceDetails: action.payload };
    case "reInitialiseData":
      return {...initialState};
    case "setCollectionData":
      return {...action.payload}
    default:
      return state;
  }
};

export default collectionReducer;